const setPageSeo= (data) => {
    return {
        type: 'SET_PAGE_SEO',
        data
    }
}

module.exports = {
    setPageSeo
}